module.exports = __webpack_public_path__ + "static/media/TopIcon.9a5c3454.svg";